module.exports = __webpack_public_path__ + "static/media/EPLD@2x(Green).f3c68bc7.png";